import React, { useRef, useState, useEffect } from "react";

const Footer2 = () => {
  const footerStyle = {
    backgroundColor: "#333", // Dark background for contrast
    color: "#fff", // Light text
    padding: "5px 8%",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: "0.9rem",
    borderTop: "5px solid #a3ff85", // Accent color line
  };

  const footerLinkContainerStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginBottom: "20px",
    flexWrap: "wrap",
  };

  const footerLinkStyle = {
    color: "#a3ff85",
    textDecoration: "none",
    fontWeight: "600",
    transition: "color 0.3s ease",
  };

  const socialIconStyle = {
    width: '30px',
    height: '30px',
    margin: '0 10px',
    cursor: 'pointer',
    filter: 'invert(100%)', // Invert for visibility on dark background
    transition: 'filter 0.3s ease',
  };

  const copyrightStyle = {
    marginTop: "15px",
    fontSize: "0.85rem",
    color: "#ccc",
  };

  return (
    <footer style={footerStyle}>
      <div style={footerLinkContainerStyle}>
        <a href="/#about" style={footerLinkStyle} aria-label="Go to About Us section">
          About Us
        </a>
        <a href="/Careers" style={footerLinkStyle} aria-label="Go to Careers section">
          Careers
        </a>
        <a href="/#contact" style={footerLinkStyle} aria-label="Go to Contact Us section">
          Contact
        </a>
        <a href="https://ibanklive.com" target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>
          iBankLive
        </a>
      </div>

      <div>
        <a href="https://in.linkedin.com/company/indycium" target="_blank" rel="noopener noreferrer" aria-label="Indycium LinkedIn">
          <img src="/images/link.png" alt="LinkedIn" style={{...socialIconStyle,width:"50%",height:"auto"}} />
        </a>
        <a href="mailto:info@indycium.com" aria-label="Indycium Email">
          <img src="/images/email.png" alt="Email" style={socialIconStyle} />
        </a>
      </div>

      <p style={copyrightStyle}>
        © {new Date().getFullYear()} Indycium. All rights reserved. | <a href="mailto:info@indycium.com" style={footerLinkStyle}>info@indycium.com</a>
      </p>
    </footer>
  );
};
export default Footer2;